/***Dependencies */
import React, { useEffect, useState } from "react";

/**Components */
import { Swiper, SwiperSlide } from "swiper/react";

/**Styles */
import "../styles/index.scss";

import { SearchEngine } from "./SearchEngine";
import { Card, Container, Tab, Tabs } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import { Autoplay } from "swiper/modules";
import { elementoPorSeccion } from "../services/adminProductService";

/**
 * Componente principal que muestra el banner con carrusel, inputs de búsqueda y selector de habitaciones.
 * @param {array} imgsBanner - Arreglo de objetos con propiedades "image" que contienen la ruta de
 *                              las imágenes del carrusel.
 * @param {boolean} showSearch - Indica si se muestra el formulario de búsqueda o no.
 * @returns {React.Component} - Componente principal con el banner y los inputs de búsqueda.
 */
export const PrincipalBanner = ({
  idSeccion,
  principalTitle,
  principalSubTitle,
  infoTraslados,
  destination,
  aeropuertoFrom,
  hotelTo,
}) => {
  const location = useLocation();
  const [imgSection, setImgSection] = useState([]);
  const [isMobile, setIsMobile] = useState(false);
  const isHome = location.pathname === "/";
  const isHoteles = location.pathname === "/hoteles";
  const isExperiencias = location.pathname === "/experiencias";
  const isTraslados = location.pathname === "/traslados";

  let idCard = "";
  let idTab = "";

  switch (location.pathname) {
    case "/hoteles":
      idCard = "one-card-selector";
      idTab = "one-tab-selector";
      break;
    case "/experiencias":
      idCard = "one-card-experiencias-selector";
      idTab = "one-tab-experiencias-selector";
      break;
    case "/traslados":
      idCard = "one-card-traslados-selector";
      idTab = "one-tab-traslados-selector";
      break;
    default:
      idCard = "card-selector";
      idTab = "tab-selector";
      break;
  }
  /** Detectar si es móvil */
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize(); // inicial
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    const fetchIdSeccion = async () => {
      try {
        const response = await elementoPorSeccion(idSeccion);
        setImgSection(response);
      } catch (error) {
        throw new Error("error fetching the imgs" + error);
      }
    };
    fetchIdSeccion();
  }, [location?.pathname, idSeccion]);
  return (
    <>
      <div
        className="banner-principal"
        style={{
          paddingTop: isMobile ? "4rem" : "0px",
          height: isMobile ? "auto" : "650px",
        }}
      >
        {/* Carrusel */}
        <div className="d-md-block d-none">
          <Swiper
            pagination={{ clickable: true }}
            style={{ width: "100%", height: "100%", position: "static" }}
            loop={true}
            speed={1000}
            autoplay={{
              delay: 3000,
            }}
            modules={[Autoplay]}
          >
            {imgSection?.[0]?.imagenes?.map((slide, index) => (
              <SwiperSlide key={index + 1} style={{ position: "static" }}>
                <div className="p-4">
                  <img
                    src={`https://panel.marzahtravel.com/assets/uploads/elementos/${slide.url}`}
                    alt={`Slide ${index + 1}`}
                    className="banner-principal__img shadow rounded-5"
                    style={{ position: "static" }}
                    height={400}
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        {/* <SearchEngine
          title={principalTitle}
          alojamientos={false}
          totalRooms={[]}
          totalPersons={[]}
          destination={""}
          arrayRooms={[]}
          isHotel={true}
          isModify={false}
          isExperiencias={false}
          isTraslados={false}
        /> */}
        <Container className="container-selector" style={{ zIndex: "1000" }}>
          <Card className="card-selector shadow" id={idCard}>
            <Card.Body className="home-padding">
              {isHome ? (
                <Tabs
                  defaultActiveKey="hotels"
                  id={idTab}
                  className="mb-3 fw-lighter"
                >
                  <Tab eventKey="hotels" title="Hoteles">
                    <SearchEngine
                      title={principalTitle}
                      imgSection={imgSection}
                      subtitle={principalSubTitle}
                      isSeccionHome={true}
                      alojamientos={false}
                      totalRooms={[]}
                      totalPersons={[]}
                      destination={""}
                      arrayRooms={[]}
                      isHotel={true}
                      isModify={false}
                      isExperiencias={false}
                      isTraslados={false}
                    />
                  </Tab>

                  <Tab eventKey="activities" title="Experiencias">
                    <SearchEngine
                      title={principalTitle}
                      subtitle={principalSubTitle}
                      imgSection={imgSection}
                      isSeccionHome={true}
                      isHotel={false}
                      totalPersons={[]}
                      totalRooms={[]}
                      destination={""}
                      arrayPersons={[]}
                      isModify={false}
                      actividades={false}
                      isExperiencias={true}
                      isTraslados={false}
                    />
                  </Tab>

                  <Tab eventKey="translates" title="Traslados">
                    <SearchEngine
                      title={principalTitle}
                      subtitle={principalSubTitle}
                      imgSection={imgSection}
                      isSeccionHome={true}
                      isHotel={false}
                      totalPersons={[]}
                      trasladosSearch={infoTraslados}
                      totalRooms={[]}
                      destination={destination}
                      arrayPersons={[]}
                      isModify={false}
                      actividades={false}
                      isExperiencias={false}
                      isTraslados={true}
                      aeropuertoFrom={aeropuertoFrom}
                      hotelTo={hotelTo}
                    />
                  </Tab>
                </Tabs>
              ) : (
                <>
                  {isHoteles && (
                    <SearchEngine
                      title={principalTitle}
                      imgSection={imgSection}
                      subtitle={principalSubTitle}
                      isSeccionHome={false}
                      alojamientos={false}
                      totalRooms={[]}
                      totalPersons={[]}
                      destination={""}
                      arrayRooms={[]}
                      isHotel={true}
                      isModify={false}
                      isExperiencias={false}
                      isTraslados={false}
                    />
                  )}

                  {isExperiencias && (
                    <SearchEngine
                      title={principalTitle}
                      subtitle={principalSubTitle}
                      imgSection={imgSection}
                      isSeccionHome={false}
                      isHotel={false}
                      totalPersons={[]}
                      totalRooms={[]}
                      destination={""}
                      arrayPersons={[]}
                      isModify={false}
                      actividades={false}
                      isExperiencias={true}
                      isTraslados={false}
                    />
                  )}

                  {isTraslados && (
                    <SearchEngine
                      title={principalTitle}
                      subtitle={principalSubTitle}
                      imgSection={imgSection}
                      isSeccionHome={false}
                      isHotel={false}
                      totalPersons={[]}
                      trasladosSearch={infoTraslados}
                      totalRooms={[]}
                      destination={destination}
                      arrayPersons={[]}
                      isModify={false}
                      actividades={false}
                      isExperiencias={false}
                      isTraslados={true}
                      aeropuertoFrom={aeropuertoFrom}
                      hotelTo={hotelTo}
                    />
                  )}
                </>
              )}
            </Card.Body>
          </Card>
        </Container>
      </div>
    </>
  );
};
